import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';
import mockSize from '../../mocks/vessel/size.json';

const vesselSizes = (
    state = {
        items: [],
        user: {
            email: '',
                company: '',
                name: '',
                surname: '',
                phones: [{
                    code: '',
                    phone: '',
                }],
        }
    }, action) => {
    switch (action.type) {
        case actionTypes.REMOVE_ALL_VESSEL_SIZES: {
            return {
                ...state,
                items: [],
            };
        }
        case actionTypes.UPDATE_VESSEL_SIZE_USER: {
            const newState = _.cloneDeep(state);
            newState.user = {
                ...action.user,
            }
            return newState;
        }
        case actionTypes.CREATE_VESSEL_SIZES: {
            return {
                ...state,
                items: action.items,
            };
        }
        case actionTypes.GET_VESSEL_SIZES: {
            return state;
        }
        case actionTypes.REMOVE_LAST_VESSEL_SIZE: {
            const newState = _.cloneDeep(state);
            newState.items.splice(-1, 1);
            return newState;
        }
        case actionTypes.ADD_VESSEL_SIZE: {
            const newState = _.cloneDeep(state);
            const cloneMockSize = _.cloneDeep(mockSize);
            newState.items.push({ ...cloneMockSize });
            return newState;
        }
        case actionTypes.UPDATE_VESSEL_SIZE: {
            const newState = _.cloneDeep(state);
            newState.items[action.numberSize] = action.newVesselSize;
            return newState;
        }
        
        default:
            return state;
    }
};

export default vesselSizes;


// WEBPACK FOOTER //
// ./app/reducers/vessels/size.js